import { Option } from "./types";

export const debounce = (callback: any, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};

export const isNumber = (value: any): boolean => {
  if (typeof value === "number") return true;
  if (typeof value === "string") return !isNaN(Number(value.trim()));
  return false;
};

export const generateMonthsArray = () => {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
};

export const getMonthsWithIndex = () => {
  return [
    { value: "1", label: "January" },
    { value: "2", label: "February" },
    { value: "3", label: "March" },
    { value: "4", label: "April" },
    { value: "5", label: "May" },
    { value: "6", label: "June" },
    { value: "7", label: "July" },
    { value: "8", label: "August" },
    { value: "9", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];
};

export const getMonthName = (monthNumber: number): string => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if (monthNumber >= 1 && monthNumber <= 12) {
    return months[monthNumber - 1];
  }

  return "Invalid Month";
};

export const months = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JUL",
  "AUG",
  "SEP",
  "OCT",
  "NOV",
  "DEC",
];

export const MIME_TYPES = {
  excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv",
  pdf: "application/pdf",
};

export const getFormattedTimestamp = () => {
  const now = new Date();
  const hours = now.getHours().toString().padStart(2, "0");
  const minutes = now.getMinutes().toString().padStart(2, "0");
  const seconds = now.getSeconds().toString().padStart(2, "0");
  return `${hours}_${minutes}_${seconds}`;
};

export const getListId = (idx: number) => {
  return idx + 1;
};

export function formatFileName(str: string): string {
  return str
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, "")
    .replace(/\s+/g, "-");
}

export function generateExportFileName(
  title?: string,
  fileExtension: string = "xlsx"
): string {
  const formattedTitle = title ? formatFileName(title) : "";
  const date = new Date().toISOString().slice(0, 10);
  const timestamp = getFormattedTimestamp();

  return `${formattedTitle}${
    formattedTitle ? "-" : ""
  }${date}_${timestamp}.${fileExtension}`;
}

export function sortAsc(a: Option, b: Option) {
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b; 
  }
  return String(a).localeCompare(String(b)); 
}
